export default "/assets/images/tech_page_01_sm.919f3c225fedc0ac.mp4";